import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import Dialogs from './Dialogs';
import { getCurrentOpenDialog } from 'store/dialogs/selectors';

const mapStateToProps = createSelector(
  getCurrentOpenDialog,
  currentOpenDialog => ({ currentOpenDialog })
);

export default connect(mapStateToProps)(Dialogs);



// WEBPACK FOOTER //
// ./src/components/dialogs/Dialogs/index.js